/**
 * Main-canvas polygon drawing visuals and interaction ids.
 */
export const PolygonDrawingStyle = {
	draftPolygonLabel: 'draft-polygon-frame',
	snappedDraftPolygonLabel: 'draft-polygon-frame-snapped',
	closedPolylineDraftLabel: 'draft-closed-polyline-frame',
	closedPolylineDraftColor: 0xff0000,
	closedPolylineDraftWidthScreenPx: 2,
	closedPolylineDraftDashScreenPx: 3,
	closedPolylineDraftGapScreenPx: 3,
	closedPolylineSnapRadiusScreenPx: 10,
	closedPolylinePointRadiusScreenPx: 4,
	closedPolylineClosureRadiusScreenPx: 7,
	closedPolylineGuidanceAlignmentEpsilonPx: 0.5,
	/** Absolute canvas-angle increment enforced by closed-polyline Ortho mode. */
	closedPolylineOrthoAngleIncrementDegrees: 15,
	/** Screen-space radius from a moved edge to a stationary guidance axis. */
	frameGuidanceLineRadiusScreenPx: 30,
	/** Screen-space capture radius for snapping a moved edge to a guidance axis. */
	frameGuidanceSnapRadiusScreenPx: 5,
	/** Slightly tighter capture radius for arrow-key frame movement. */
	frameKeyboardGuidanceSnapRadiusScreenPx: 4,
	/** Maximum angular difference for a stationary edge to guide a moved frame edge. */
	frameGuidanceParallelAngleToleranceDegrees: 2,
	/** Thin fourth-point construction ray shown after three polyline vertices. */
	closedPolylineGuideWidthScreenPx: 1,
	editDraftPolygonLabel: 'draft-polygon-frame-edit',
	splitPreviewLabel: 'draft-polygon-frame-split',
	/** Bright-red cut line; acts as the cursor while the split tool is on. */
	splitPreviewColor: 0xff0000,
	/** Each end of the cut line extends past the frame by this fraction of the frame span. */
	splitPreviewOverhangRatio: 0.8,
	activeEndlineLabel: 'polygon-active-endline',
	/** Corner-node overlay graphic inside `main-container`; hidden during edge drags. */
	cornerOverlayGraphicsLabel: 'frame-corner-edit',
	/** Cursor-anchored thickness readout shown during a long-edge thickness drag. */
	thicknessIndicatorLabel: 'polygon-thickness-indicator',
	/** Live thickness readout between a closed-polyline draft's second and third clicks. */
	closedPolylineThicknessIndicatorLabel: 'closed-polyline-thickness-indicator',
	endDraftTerminationLabel: 'polygon-end-draft-termination',
	/** Solid red dragged-edge line drawn above the fill during an end drag. */
	endDraftTerminationWidth: 1.5,
	/** Edit drafts render outline-only, slightly thinner than the committed outline. */
	editDraftOutlineWidth: 0.875,
	frameOutlinePolygonLayerId: 'frame-outline-polygons',
	selectableFramePolygonLayerId: 'selectable-frame-polygons',
	snapLineColor: 0xff0000,
	selectedFrameOutlineColor: 0x000000,
	activeEndlineColor: 0xff0000,
	idleFrameFillAlpha: 0.12,
	hoveredFrameFillAlpha: 0.35,
	legendActiveRowClassName: 'bg-surface-150',
	legendInactiveRowClassName: 'bg-transparent',
	minSnappedWallLength: 1,
	/** Corridors wider than the largest catalog wall thickness x this are ignored. */
	maxCorridorWidthFactor: 1.25,
} as const;
